<template>
  <div @keydown.enter="goLogin" id="index-wrap">
    <HeaderArea class="header-box" :headerIsfix="headerIsfix"></HeaderArea>
    <div class="min-height"></div>
    <!-- 头部 -->
    <div class="header">
      <!-- 轮播 -->
      <div class="focus-box">
        <div class="swiper-container focus-box-swiper">
          <div class="swiper-wrapper swiper-no-swiping">
            <div class="swiper-slide">
              <div class="blockChain-banner">
                <div class="container">
                  <div class="banner2-img">
                    <p class="banner2-img-title">
                      区块链+网络赋强公证，全流程在线自助办理
                    </p>
                    <p class="banner2-img-desc">
                      提高在防范和化解社会矛盾风险、推进国家诚信建设、提升社会治理能力现代化水平。符合区块链标准及网络信息安全和数据安全的规定，数据实时验证、存储、加密及电子签名等功能。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 登录 -->
      <div class="content">
        <!-- <div class="login">
          <h4>用户登录</h4>
          <span class="err-tips total-tips">{{personalInfo.totalTips}}</span>
          <p>
            <img src="../../assets/images/index/account.png" class="tipIcon" />
            <input
              type="text"
              class="long-input"
              placeholder="请输入手机号码／电子邮箱"
              v-model="personalInfo.userName"
              @blur="checkUserName"
            />
            <span class="err-tips">{{personalInfo.userNameTips}}</span>
          </p>
          <p>
            <img src="../../assets/images/index/pw.png" class="tipIcon" />
            <input
              type="password"
              class="long-input"
              placeholder="请输入密码"
              v-model="personalInfo.passWord"
              @blur="checkPassWord"
            />
            <span class="err-tips">{{personalInfo.passWordTips}}</span>
          </p>
          <p class="clearfix">
            <img src="../../assets/images/index/vcode.png" class="tipIcon" />
            <input
              type="text"
              class="short-input"
              placeholder="请输入验证码"
              v-model="personalInfo.vCode"
              @blur="checkVCode"
            />
            <img :src="vcodeUrl" @click="getVcode" class="vcode" />
            <span class="err-tips">{{personalInfo.vCodeTips}}</span>
          </p>
          <p>
            <button
              :disabled="loginBtnStatus"
              @click="goLogin"
              v-text="loginText"
              :class="{'loginDisabled': loginBtnStatus,}"
            ></button>
          </p> -->
        <!-- <div class="more-option">
            <span>验证码登录</span>
            <span>
              <a href="javascript:;">立即注册&nbsp;/&nbsp;</a><a href="javascript:;" >&nbsp;找回密码</a>
            </span>
          </div> -->
        <div class="loginBox">
          <div class="loginRight fr loginPhone">
            <h3 class="ft18 textAlign loginTitle">用户登录</h3>
            <p class="errorHint" v-show="errorBox">
              <img src="../../assets/images/login/warning_icon.png" />
              {{ error }}
            </p>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
              @keyup.enter.native>
              <el-form-item label prop="logPhone">
                <el-input type="text" v-model="ruleForm.logPhone" placeholder="手机号/邮箱" autocomplete="off"
                  autofocus="autofocus" @keyup.enter.native="submitForm('ruleForm')"></el-input>
              </el-form-item>
              <el-form-item label prop="logPwd">
                <el-input type="password" v-model="ruleForm.logPwd" placeholder="密码" autocomplete="off"
                  autofocus="autofocus" @keyup.enter.native="submitForm('ruleForm')"></el-input>
              </el-form-item>
              <el-form-item label prop="logCode">
                <el-input type="text" v-model="ruleForm.logCode" placeholder="请输入验证码" autocomplete="off"
                  @keyup.enter.native="submitForm('ruleForm')"></el-input>
                <span class="code">
                  <img @click="codeFn" :src="ruleForm.img" />
                </span>
              </el-form-item>
              <el-form-item>
                <el-button v-if="notLogin" type="success" id="submitFn" @click="submitForm('ruleForm')">登录</el-button>
                <el-button v-if="!notLogin" type="success" id="submitFn" :disabled="true">登录</el-button>
              </el-form-item>
              <div class="lgTigger">
                <span class="fl ft12" @click="phoneLogin(1, 'ruleForm')">验证码登录</span>
                <div class="fr">
                  <router-link class="ft12" tag="span" to="/verification/register">立即注册</router-link>
                  <span class="lines ft12">&nbsp;/&nbsp;</span>
                  <router-link class="ft12" tag="span" to="/verification/forgetpwd">忘记密码</router-link>
                </div>
              </div>
            </el-form>
          </div>
          <div class="loginRight fr loginCode">
            <h3 class="ft18 textAlign loginTitle">手机登录</h3>
            <p class="errorHint" v-show="errorBox">
              <img src="../../assets/images/login/warning_icon.png" />
              {{ error }}
            </p>
            <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px"
              class="demo-ruleForm demos-ruleForm" @keyup.enter.native>
              <el-form-item label prop="logPhone">
                &nbsp;&nbsp;&nbsp;+86&nbsp;&nbsp;&nbsp;
                <el-input type="text" v-model="ruleForm2.logPhone" autofocus="autofocus" placeholder="手机号" id="photoCode"
                  @keyup.enter.native="submitForm2('ruleForm2')"></el-input>
              </el-form-item>
              <el-form-item label prop="logCode">
                <el-input type="text" v-model="ruleForm2.logCode" autofocus="autofocus" placeholder="请输入验证码"
                  autocomplete="off" @keyup.enter="submitForm2('ruleForm2')"></el-input>
                <span v-show="sendAuthCode" class="code PhotoCode" @click="getCode">获取验证码</span>
                <span v-show="!sendAuthCode" class="code PhotoCode" style="color: #d81212; border-color: #a5303d">{{
                  auth_time }}秒后重新获取</span>
              </el-form-item>
              <el-form-item>
                <el-button type="success" id="submitFns" @click="submitForm2('ruleForm2')" v-if="notLoginP">登录</el-button>
                <el-button type="success" id="submitFns" v-loading="loading" :disabled="true"
                  v-if="!notLoginP">登录</el-button>
              </el-form-item>
              <p>
                <span class="ft12 switchUser" @click="phoneLogin(2, 'ruleForm2')">用户名密码登录</span>
              </p>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!--核心产品-->
    <div class="core-area">
      <p class="core-area-title"><span></span>核心产品</p>
      <div class="core-area-content">
        <div class="core-area-content-con">
          <!-- @mouseenter="forensicsMouseup(true,index,coreArea)" @mouseleave="forensicsMouseup(false,index,coreArea)" -->
          <div class="core-lump" v-for="(i, index) in coreArea" :key="index">
            <img :src="i.imghover" />
            <div class="lump-title">
              <h3>{{ i.title }}</h3>
              <span></span>
              <p v-html="i.message"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-core">
      <p class="product-core-title">产品优势</p>
      <div class="content">
        <div class="subitem-box">
          <div class="core-desc">
            <P>{{ productCore.coreDescOne }}</P>
            <P>{{ productCore.coreDescTwo }}</P>
          </div>
          <div class="core-list">
            <p :class="{ marginbtm: index <= 2 }" v-for="(item, index) in productCore.list" :key="index">
              <img :src="item.imghover" alt="" />
              <span>{{ item.title }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- API开放接口 -->
    <div class="forensics-home">
      <p class="core-area-title">
        API开放接口<span>与金融机构系统进行快速集成，实现赋强公证相关功能。</span>
      </p>
      <div class="content">
        <div class="subitem-box">
          <div class="subitem" v-for="(i, index) in forensics" :key="index">
            <div class="subitem-info">
              <img class="subitem-info-icon" :src="i.img" alt="" />
              <h3>{{ i.title }}</h3>
              <p>{{ i.message }}</p>
            </div>
            <img v-if="index != 3" class="connect" src="../../assets/images/index/connect.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 技术赋能 -->
    <div class="technology">
      <p class="core-area-title quzheng">技术赋能</p>
      <span class="technology-line"></span>
      <div class="content">
        <div class="technology-box">
          <dl v-for="(item, index) in technology" :key="index">
            <dt>
              <img :src="item.img" />
            </dt>
            <dd>
              <h4>{{ item.title }}</h4>
              <p>{{ item.desc }}</p>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <!-- 存证ID查询 -->
    <div class="searchs" id="particles">
      <div class="search_warrp">
        <div class="search_type">
          <input type="text" placeholder="存证ID查询" v-model="proofId" />
          <div class @click="searchID"></div>
        </div>
        <el-table :data="searchList" style="width: 100%; margin-bottom: 10px" border
          header-cell-class-name="cellCustomer headerCellCustomer ft14" cell-class-name="cellCustomer ft12" class="elTab">
          <el-table-column prop="createTime" label="存证时间"></el-table-column>
          <el-table-column prop="txId" label="存证ID" width="300"></el-table-column>
          <el-table-column label="节点信息" prop="user">
            <template slot-scope="scope">
              <span>Xcontract</span>
            </template>
          </el-table-column>
          <el-table-column label="用户主体" prop="owner"></el-table-column>
          <el-table-column label="区块Hash" prop="blockHash" width="300"></el-table-column>
          <div class="no-data" v-if="!searchList.length" slot="empty">
            <img src="../../assets/images/index/no_search.png" alt />
            <br />
            <span>{{ noDataText }}</span>
          </div>
        </el-table>
      </div>
    </div>
    <!-- 区块链存证记录 -->
    <div class="blockChainItem">
      <p class="core-area-title" style="padding-bottom: 40px; margin-top: -64px">
        <span></span>区块链存证记录
      </p>
      <div class="blockChainItem_con">
        <div class="blockChainItem_title">
          <img src="../../assets/images/index/legal_jl_img.png" alt />
        </div>
        <div class="table clearfix">
          <table class="table" style="white-space: normal; word-break: break-all; height: 689px">
            <thead style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                z-index: 3;
              ">
              <tr style="
                  background-color: #d2d2d2 !important;
                  width: 100%;
                  float: left;
                ">
                <td class="common-td" style="width: 15%">存证时间</td>
                <td class="common-td" style="width: 33%">存证ID</td>
                <!-- <td class="common-td" style="width: 14%;">节点信息</td> -->
                <td class="common-td" style="width: 19%">用户主体</td>
                <td class="common-td" style="width: 33%">区块Hash</td>
              </tr>
            </thead>
            <tbody class="table-list" v-if="list.length">
              <tr v-for="(item, index) in list" :key="index">
                <td style="width: 14%">{{ item.signTime }}</td>
                <td style="width: 33%">{{ item.txid }}</td>
                <!-- <td style="width: 14%;">{{item.contractid}}</td> -->
                <td style="width: 14%">{{ item.owner }}</td>
                <td style="width: 33%">{{ item.datahash }}</td>
              </tr>
            </tbody>
            <div class="nodata-list" v-else>
              <img src="../../assets/images/index/nodata_icon.png" />
              <span>暂无数据</span>
            </div>
          </table>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="cooperators">
      <p class="core-area-title titleH">合作伙伴</p>
      <div class="content">
        <div class="subitem-box">
          <table style="border-collapse: collapse">
            <tr>
              <td v-for="(item, index) in cooperators.slice(0, 6)" :key="index">
                <div class="cooperators-item"><img :src="item" alt="" /></div>
              </td>
            </tr>
            <tr>
              <td v-for="(item, index) in cooperators.slice(6, 12)" :key="index">
                <div class="cooperators-item"><img :src="item" alt="" /></div>
              </td>
            </tr>
            <tr>
              <td v-for="(item, index) in cooperators.slice(12, 18)" :key="index">
                <div class="cooperators-item"><img :src="item" alt="" /></div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- 更多功能 -->
    <div class="more-fn">
      <transition name="fade">
        <div class="backtop single-fn" v-if="isShowBackTop" @click="backTop">
          <img src="../../assets/images/index/top.png" />
        </div>
      </transition>
    </div>
    <!-- 侧边栏 -->
    <!-- <Drawer :opens="true"></Drawer> -->
    <!-- 用户协议 -->
    <!-- <agreeMent v-if="isshow" @closeModal="closeModal" @agreesure="agreesure"></agreeMent> -->
    <!-- <MsgModalError :text='"网站升级中暂停访问"'></MsgModalError> -->
    <FooterArea></FooterArea>

    <!-- <ContactInformation /> -->
  </div>
</template>

<script>
import $ from "jquery";
import Swiper from "swiper";
import "../../assets/css/swiper.min.css";
import HeaderArea from "../common/HeaderArea.vue";
import FooterArea from "../common/FooterArea.vue";
import MsgModalError from "../common/MsgModalError.vue";
// import ContactInformation from "../common/contactInformation.vue";

import BaseApi from "@lib/baseApi.js";
import md5 from "@lib/encryption.js";
import { mapMutations } from "vuex";
import config from "@lib/config.js";
export default {
  name: "Index",
  components: { MsgModalError, FooterArea, HeaderArea },
  data() {
    var validateName = (rule, value, callback) => {
      var emilReg =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      var photoReg =
        /^((13[0-9])|(15[0-9])|(14[0-9])|(16[0-9])|(17[0-9])|(18[0-9])||(19[0-9]))\d{8}$/;
      var photo_test = /^1545678\d{4}$/;
      if (
        photoReg.test(value) ||
        emilReg.test(value) ||
        photo_test.test(value)
      ) {
        var params = { account: value };
        BaseApi.createRpcToken("/user/checkAccount", params)
          .then((data) => {
            if (data.datas.code == 3007) {
              this.isExist = false;
            } else if (data.datas.code == 3001) {
              this.isExist = true;
            }
            if (
              !photoReg.test(value) &&
              !emilReg.test(value) &&
              !photo_test.test(value)
            ) {
              callback(new Error("用户名格式错误"));
            } else if (this.isExist == true) {
              callback();
            } else if (this.isExist == false) {
              callback(new Error("用户不存在"));
            } else {
              callback();
            }
          })
          .catch(function (e) {
            errorLog(e);
          });
      } else {
        console.log(!photoReg.test(value));
        console.log(!photo_test.test(value));
        console.log(!emilReg.test(value));
        if (!photoReg.test(value) && !emilReg.test(value)) {
          callback(new Error("用户名格式错误"));
        }
        callback();
      }
    };
    var validatePhoto = (rule, value, callback) => {
      var photoReg =
        /^((13[0-9])|(15[0-9])|(14[0-9])|(16[0-9])|(17[0-9])|(18[0-9])||(19[0-9]))\d{8}$/;
      if (photoReg.test(value)) {
        var queryStr = {
          account: value,
        };
        BaseApi.createRpcToken("/user/checkAccount", queryStr)
          .then((data) => {
            if (data.datas.code == 3007) {
              this.isExistPhoto = false;
            } else if (data.datas.code == 3001) {
              this.isExistPhoto = true;
            }
            if (!photoReg.test(value) && !emilReg.test(value)) {
              callback(new Error("用户名格式错误"));
            } else if (this.isExistPhoto == true) {
              callback();
            } else if (this.isExistPhoto == false) {
              callback(new Error("用户不存在"));
            } else {
              callback();
            }
          })
          .catch(function (e) {
            errorLog(e);
          });
      }
    };
    return {
      isshow: false,
      startMove: false,
      headerIsfix: false,
      isShowBackTop: false,
      sceneDescShow: false,
      sceneRotateIndex: 0,
      sceneRotateTimer: null,
      sceneStartRotate: false,
      coreArea: [
        {
          title: "区块链赋强公证系统",
          active: false,
          imghover: require("../../assets/images/index/coreArea1.png"),
          message:
            "为解决不良贷款催收难的痛点问题提供技术路径，大大简化不良贷款处置流程为金融机构提供线上强执公证服务，通过线上赋强公证服务平台，将公证处与银行业务进行链接。",
        },
        {
          title: "区块链赋强小程序",
          active: false,
          imghover: require("../../assets/images/index/coreArea2.png"),
          message:
            "通过手机端快速完成赋强公证办理过程，通过SDK实现与银行客户端的无缝对接，为用户构建省时省力的服务体。",
        },
        {
          title: "区块链公证管理系统",
          active: false,
          imghover: require("../../assets/images/index/coreArea3.png"),
          message:
            "审批赋强公证申请，及时生成电子公证书，在出现违约的情况下，即可启动催告并对催告内容进行存证，催告无果后金融机构可申请强执流程。",
        },
        {
          title: "区块链法院案件查询系统",
          active: false,
          imghover: require("../../assets/images/index/coreArea4.png"),
          message:
            "对证据真实性、合规性等进行校验，完成证据的采集，并依托网络赋强公证申请的强执，可不打官司直接走执行程序，司法效力被主管部门认可，并已有执行判例。",
        },
      ],
      productCore: {
        list: [
          {
            title: "降低不良坏账",
            active: false,
            imghover: require("../../assets/images/index/product-core-1.png"),
          },
          {
            title: "签署借贷协议",
            active: false,
            imghover: require("../../assets/images/index/product-core-2.png"),
          },
          {
            title: "债务核实",
            active: false,
            imghover: require("../../assets/images/index/product-core-3.png"),
          },
          {
            title: "逾期催告",
            active: false,
            imghover: require("../../assets/images/index/product-core-4.png"),
          },
          {
            title: "出具强执文书",
            active: false,
            imghover: require("../../assets/images/index/product-core-5.png"),
          },
          {
            title: "法院立案执行",
            active: false,
            imghover: require("../../assets/images/index/product-core-6.png"),
          },
        ],
        coreDescOne:
          "为解决不良贷款催收难的痛点问题提供技术路径，大大简化不良贷款处置流程为金融机构提供线上强执公证服务，通过线上赋强公证服务平台，将公证处与银行业务连接起来，用赋予强制执行公证服务这一手段降低金融机构坏账率，提升银行风控能力，可最大限度的降低金融机构时间成本。",
        coreDescTwo:
          "依法凭公证机构签发的执行证书直接向有管辖权的人民法院申请强制执行，无需经过诉讼程序。",
      },
      forensics: [
        {
          title: "申请接入",
          active: false,
          img: require("../../assets/images/index/forensics-img-1.png"),
          message: "联系我们，达成合作意向，申请接入",
        },
        {
          title: "获取SDK",
          active: false,
          img: require("../../assets/images/index/forensics-img-2.png"),
          message: "申请审核通过后，获取业务开发所需SDK",
        },
        {
          title: "测试联调",
          active: false,
          img: require("../../assets/images/index/forensics-img-3.png"),
          message: "开发完成后，测试环境进行联调",
        },
        {
          title: "上线",
          active: false,
          img: require("../../assets/images/index/forensics-img-4.png"),
          message: "测试环境联调通过后，申请上线",
        },
      ],
      technology: [
        {
          img: require("../../assets/images/index/blockchain_icon.png"),
          title: "区块链",
          desc: "基于legalXchain司法联盟链，确保数据真实有效未篡改，全程司法见证，构建可信证据链。",
        },
        {
          img: require("../../assets/images/index/cloud_icon.png"),
          title: "云计算",
          desc: "基于云计算技术提供便捷高效、即需即用的存证工具，运用金融级加密算法实时存储。",
        },
        {
          img: require("../../assets/images/index/xcontrant_icon.png"),
          title: "智能合约",
          desc: "可靠合规，具有法律效力，防篡改防假冒，确保签署主体真实性。",
        },
        {
          img: require("../../assets/images/index/face_icon.png"),
          title: "活体识别",
          desc: "提供身份证OCR、面部识别等综合认证服务，有效防止用户身份冒用的风险。",
        },
      ],
      cooperators: [
        require("../../assets/images/index/cooperators/bjhlwfy.png"),
        require("../../assets/images/index/cooperators/hzhlwfy.png"),
        require("../../assets/images/index/cooperators/gzhlwfy.png"),
        require("../../assets/images/index/cooperators/zghlwfyyjy.png"),
        require("../../assets/images/index/cooperators/zgkxy.png"),
        require("../../assets/images/index/cooperators/dyyjy.png"),
        require("../../assets/images/index/cooperators/gfyh.png"),
        require("../../assets/images/index/cooperators/aly.png"),
        require("../../assets/images/index/cooperators/hwy.png"),
        require("../../assets/images/index/cooperators/hyperle.png"),
        require("../../assets/images/index/cooperators/IP360.png"),
        require("../../assets/images/index/cooperators/xcontract.png"),
      ],
      // // 登录信息
      // personalInfo: {
      //   //表单值
      //   userName: "",
      //   passWord: "",
      //   vCode: "",
      //   //提示信息
      //   userNameTips: "",
      //   passWordTips: "",
      //   vCodeTips: "",
      //   totalTips: "",
      //   //check结果
      //   userNameRes: "",
      //   passWordRes: "",
      //   vCodeRes: ""
      // },
      //用户协议 uid
      userId: "",
      //存证记录
      list: [],
      baseVcodeUrl: "",
      vcodeUrl: "",
      loginBtnStatus: false,
      loginText: "登录",
      proofId: "",
      searchList: [],
      noDataText: "暂无数据",

      /**
       * 电子签约登录
       * */
      error: "",
      notLogin: true,
      notLoginP: true,
      errorBox: false,
      sendAuthCode: true,
      auth_time: 0,
      loading: false,
      isExist: true,
      isExistPhoto: "",
      ruleForm: {
        logPhone: "",
        logPwd: "",
        logCode: "",
        img: "",
      },
      rules: {
        logPhone: [
          { required: true, message: "请输入手机号或邮箱", trigger: "blur" },
          { validator: validateName, trigger: "blur" },
        ],
        logPwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        logCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      ruleForm2: {
        logPhone: "",
        logCode: "",
      },
      rules2: {
        logPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern:
              /^((13[0-9])|(15[0-9])|(14[0-9])|(16[0-9])|(17[0-9])|(18[0-9])||(19[0-9]))\d{8}$/,
            message: "非手机号格式",
            trigger: "blur",
          },
          // { validator: validatePhoto, trigger: "blur" }
        ],
        logCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },

      // ENABLEINTEGRATION_VALUE: false, // 调赋一体化
    };
  },
  created() {
    let ENABLEINTEGRATION = JSON.parse(
      sessionStorage.getItem("ENABLEINTEGRATION")
    ) || {
      flag: 0,
      value: null, // 调赋一体化
    };
    if (ENABLEINTEGRATION.value === true) {
      this.$router.push("/integration/login?fn=logout");
    }

    BaseApi.createRpcToken("/common/getCode")
      .then(
        (data) => {
          this.ruleForm.img = "data:image/png;base64," + data.datas.code;
        },
        (data) => { }
      )
      .catch(function (e) {
        errorLog(e);
      });
    this.getVersion();
    // 获取地理位置
    //  this.getLocation();
  },
  mounted() {
    this.startMove = true;
    setTimeout(() => {
      var mySwiper = new Swiper(".swiper-container", {
        autoplay: false,
        loop: false,
        autoHeight: false,
        autoplayDisableOnInteraction: false,
        // effect: 'slide',
      });
    }, 300);
    this.init();
  },
  methods: {
    init() {
      // this.baseVcodeUrl = this.GlobalConfig.vcodeUrl;
      this.headerFix();
      this.getTxIDList();
      this.codeFn();
    },
    //监听是否有新版本
    getVersion() {
      axios
        .get("/version.json", { params: { time: new Date().getTime() } })
        .then((res) => {
          let lastVersion = res.version;
          if (localStorage.getItem("version") == null) {
            localStorage.setItem("version", lastVersion);
          } else {
            if (localStorage.getItem("version") != lastVersion) {
              localStorage.setItem("version", lastVersion);
              window.location.reload();
            }
          }
        });
    },
    getKey(row) {
      return row.txid;
    },
    getTxIDList() {
      let self = this;
      BaseApi.createRpcToken(
        "/xcontract/contract/getlatesttxinfo",
        { pageSize: 10 },
        "POST"
      )
        .then(
          (data) => {
            this.list = data.param;
            self.socket = io(config.socketIo);
            self.socket.on("connect", function () {
              self.socket.on("getblockinfo", function (msg) {
                msg = JSON.parse(msg);
              });
              self.socket.on("updatetxinfo", function (msg) {
                msg = JSON.parse(msg);
                var is = self.list.every((item, index) => {
                  return item.txid != msg.param[0].txid;
                });
                if (is) {
                  self.list.pop();
                  self.list.unshift(msg.param[0]);
                }
              });
            });
            this.h5list = this.list.slice(0, 3);
          },
          (err) => { }
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    closeModal(data) {
      this.isshow = data;
    },
    // agreesure() {
    //  BaseApi.createRpcToken(
    //        "/webapi/extractEvidence/v2/readAgreement",
    //        {
    //         userId: this.userId
    //       },
    //       "get"
    //     )
    //     .then(response => {
    //       this.Logining();
    //     });
    // },
    searchID() {
      if (this.proofId != "") {
        BaseApi.createRpcToken(
          "/webapi/tx/queryByTxId",
          { txId: this.proofId },
          "get",
          "",
          ""
        ).then((res) => {
          if (res.code == 200) {
            if (!res.extraData.data.txId) {
              return this.searchList = []
            }
            this.searchList = [res.extraData.data];
          }else if(res.code==101){
            this.searchList=[]
            this.$message.error(res.message)
          }else{
            this.searchList=[]
          }
        });
      }
    },
    backTop() {
      $(window).scrollTop(() => {
        $("body,html").animate({ scrollTop: 0 });
      });
    },
    forensicsMouseup(flag, index, list) {
      if (flag) {
        list[index].active = true;
      } else {
        list[index].active = false;
      }
    },
    headerFix() {
      let that = this;
      $("html").css({ height: "auto" });
      $(window).scroll(function () {
        if ($(window).scrollTop() > 30) {
          that.headerIsfix = true;
        } else {
          that.headerIsfix = false;
        }
        //是否显示回到顶部
        let height = $(window).height();
        if ($(window).scrollTop() > height) {
          that.isShowBackTop = true;
        } else {
          that.isShowBackTop = false;
        }
      });
    },
    // Logining() {
    //   this.personalInfo.totalTips = "";
    //   this.personalInfo.vCodeTips = "";

    //   let params = {};
    //   let initSubmit = () => {
    //     //显示提示信息
    //     this.checkUserName();
    //     this.checkPassWord();
    //     this.checkVCode();
    //   };
    //   initSubmit();
    //   console.log("#1231231")
    //   //个人登陆
    //   let res =
    //     this.personalInfo.userNameRes &&
    //     this.personalInfo.passWordRes &&
    //     this.personalInfo.vCodeRes;
    //   if (res) {
    //     params.account = this.personalInfo.userName;
    //     params.password = this.$md5(this.personalInfo.passWord);
    //     params.vcode = this.personalInfo.vCode;
    //   } else {
    //     initSubmit();
    //     //用户名
    //     let emailReg = commenConst.INPUTRULES.email;
    //     let mobileReg = commenConst.INPUTRULES.mobile;
    //     let userName = this.personalInfo.userName;
    //     if (!(emailReg.test(userName) || mobileReg.test(userName))) {
    //       this.personalInfo.userNameTips = "请输入正确的手机号或邮箱";
    //       this.personalInfo.userNameRes = "";
    //     }
    //     // 密码
    //     if (!this.personalInfo.passWord) {
    //       this.personalInfo.passWordTips = "请输入密码";
    //       this.personalInfo.passWordRes = "";
    //     }
    //     // 验证码
    //     if (!this.personalInfo.vCode) {
    //       this.personalInfo.vCodeTips = "请输入验证码";
    //       this.personalInfo.vCodeRes = "";
    //     }
    //     return;
    //   }
    //   console.log("22222222222222222222222")
    //   params.type = 1;
    //     BaseApi.createRpcToken(
    //       "/webapi/user/v2/login",
    //       params,
    //       "get",
    //     )
    //     .then(response => {
    //       let res = response.data;
    //       if (response.data.code == 200) {
    //         //清空提示
    //         this.personalInfo.totalTips = "";
    //         let user = res.datas.loginUser;
    //         user.timestamp = Date.now();
    //         user.token = response.data.datas.token;
    //         user.loginPassword = undefined;
    //         // this.$store.dispatch('showMsgModal', {
    //         //   autoClose: true,
    //         //   info: '登录成功'
    //         // })

    //         //密码保存7天
    //         let userVal = {
    //           account: params.account,
    //           password: params.password
    //         };
    //         //存入全局store

    //         //存在用户假如首次进入页面连续点击登录按钮可以请求两次login接口。登录页面之后会被重新拦截到index页
    //         this.$store.dispatch("login", user);

    //         // this.$store.commit('updateUser', user)
    //         // let IP360 = {user}
    //         // localStorage.setItem("IP360", JSON.stringify(IP360))
    //         // var redirect = this.$route.query.redirect
    //         // redirect = !!redirect ? decodeURIComponent(redirect) : '/'
    //         // this.$router.push(redirect)
    //         // // //console.log("start 1111")
    //         // setCookie('IP360', userVal, 7)

    //         // 如果成功以后跳转耗时比较久，接口已经返回成功了，但是页面处理时间比较久。所以return
    //         return;
    //       } else if (response.data.code == 1002) {
    //         this.personalInfo.vCodeTips = res.message;
    //         this.personalInfo.vCodeRes = false;
    //         this.getVcode();
    //       } else {
    //         this.personalInfo.totalTips = res.message;
    //         this.getVcode();
    //       }
    //       this.loginBtnStatus = false;
    //       this.loginText = "登录";
    //     });
    // },
    openUrl(url, state) {
      if (!this.loginBtnStatus) {
        if (state) {
          window.open(url);
        }
        this.$router.push(url);
      }
    },
    // getBlockChain () {
    //   //console.log("getBlockChain")
    //   this.$axios.get('/webapi/extractEvidence/v2/getBlockHeightAndTxCount', {
    //     params: {
    //       a: 1,
    //     }
    //   }).then(response => {
    //     //console.log(response)
    //     if (response.data.code == 200) {
    //       this.blockChain.blockHeight = response.data.datas.blockHeight
    //       this.blockChain.nodeNumber = response.data.datas.peerCount
    //       this.blockChain.transactionNumber = response.data.datas.txCount
    //     }
    //   })
    // },
    ...mapMutations(["setUserInfo", "setLocation"]),
    phoneLogin(num, formName) {
      this.errorBox = false;
      this.$refs["ruleForm"].resetFields();
      this.$refs["ruleForm2"].resetFields();
      if (num == 1) {
        $(".loginPhone").css("display", "none");
        $(".loginCode").css("display", "block");
        $(document).keyup(function (event) {
          if (event.keyCode == 13) {
            $("#submitFns").trigger("click");
            $("#submitFn").trigger("");
          }
        });
      } else {
        $(document).keyup(function (event) {
          if (event.keyCode == 13) {
            $("#submitFns").trigger("");
            $("#submitFn").trigger("click");
          }
        });
        $(".loginPhone").css("display", "block");
        $(".loginCode").css("display", "none");
      }
    },
    submitForm(formName) {
      sessionStorage.clear();
      this.loginCheck();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.notLogin = false;
          var queryStr = {
            account: this.ruleForm.logPhone,
            password: md5.md5(this.ruleForm.logPwd),
            imageCode: this.ruleForm.logCode,
          };
          BaseApi.createRpcToken("/user/login", queryStr, "post", "", "", false)
            .then(
              (data) => {
                this.notLogin = false;
                if (data.code == 200) {
                  this.loading = false;
                  this.errorBox = false;
                  localStorage.setItem("token", data.datas.token);
                  localStorage.setItem("userId", data.datas.userId);
                  BaseApi.createRpcToken("/user/v2/getUserInfo").then(
                    (data) => {
                      sessionStorage.setItem(
                        "userInfo",
                        JSON.stringify(data.datas)
                      );
                      localStorage.setItem("curID", data.datas.currentUserId);
                      this.setUserInfo(data.datas);
                      localStorage.loginType = "password";
                      // localStorage.setItem("curUserId", data.datas.currentUserId);

                      this.$router.push({
                        path: "/personal/home",
                      });
                      // if (this.ENABLEINTEGRATION_VALUE) {
                      //   // 开启调赋一体化 去调解当事人端把token存起来
                      //   location.href =
                      //     process.env.VUE_APP_PARTY_HOME +
                      //     "?ht=" +
                      //     localStorage.getItem("token") +
                      //     "&hb=" + process.env.VUE_APP_FQ_HOME;
                      // } else {
                      //   this.$router.push({
                      //     path: "/personal/home"
                      //   });
                      // }
                    },
                    (err) => { }
                  );
                } else {
                  this.notLogin = true;
                }
              },
              (data) => {
                this.notLogin = true;
                this.errorBox = true;
                this.loading = false;
                this.error = data.message;
                this.codeFn();
              }
            )
            .catch(function (e) {
              errorLog(e);
            });
        } else {
          this.notLogin = true;
          this.loading = false;
          return false;
        }
      });
    },
    getLocation() {
      // BaseApi.createRpcToken("/getToken").then(
      //   data => {
      //     window.token = data.result;
      //   },
      //   err => {}
      // );

      BaseApi.createRpcToken("/getLocation")
        .then(
          (data) => {
            let dataTemp = {
              location: data.result.ad_info.city + data.result.ad_info.district,
              LocationAttr:
                data.result.location.lng + "," + data.result.location.lat,
            };
            this.setLocation(dataTemp);
            sessionStorage.setItem("locationInfo", JSON.stringify(dataTemp));
          },
          (err) => { }
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //校验是否第一次登录
    loginCheck() {
      let mobile = this.ruleForm.logPhone;
      BaseApi.createRpcToken(
        "/user/loginCheck",
        { account: mobile },
        "post"
      ).then((res) => {
        if (res.code == 200) {
          this.isShowGuide = res.datas.isRead;
          sessionStorage.setItem("isRead", res.datas.isRead);
        }
      });
    },
    submitForm2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.notLoginP = false;
          var queryStr = {
            account: this.ruleForm2.logPhone,
            smsCode: this.ruleForm2.logCode,
          };
          BaseApi.createRpcToken("/user/login", queryStr, "post", "", "", false)
            .then(
              (data) => {
                this.notLoginP = false;
                if (data.code == 200) {
                  this.errorBox = false;
                  localStorage.setItem("token", data.datas.token);
                  localStorage.setItem("userName", this.ruleForm2.logPhone);
                  this.loading = false;
                  // sessionStorage.setItem("token",data.datas.token);
                  localStorage.loginType = "verificationCode";
                  this.$router.push({
                    path: "/personal/home",
                  });
                } else {
                  this.notLoginP = true;
                }
              },
              (data) => {
                this.notLoginP = true;
                this.errorBox = true;
                this.loading = false;
                this.error = data.message;
              }
            )
            .catch(function (e) {
              errorLog(e);
            });
        } else {
          this.notLoginP = true;
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode() {
      if (this.ruleForm2.logPhone != "") {
        var photoReg =
          /^((13[0-9])|(15[0-9])|(14[0-9])|(16[0-9])|(17[0-9])|(18[0-9])||(19[0-9]))\d{8}$/;
        if (photoReg.test(this.ruleForm2.logPhone)) {
          var queryStr = {
            mobile: this.ruleForm2.logPhone,
          };
          BaseApi.createRpcToken("/common/getLoginCode", queryStr)
            .then(
              (data) => { },
              (data) => {
                console.log(data);
              }
            )
            .catch(function (e) {
              errorLog(e);
            });
          this.sendAuthCode = false;
          this.auth_time = 60;
          var auth_timetimers = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendAuthCode = true;
              clearInterval(auth_timetimers);
            }
          }, 1000);
        }
      } else {
        this.$refs.ruleForm2.validateField("logPhone");
      }
    },
    codeFn() {
      let date = new Date().getTime();
      // this.ruleForm.img = `http://192.168.1.105:8080/common/getCode?date=${date}`;
      BaseApi.createRpcToken(`/common/getCode?date=${date}`)
        .then(
          (data) => {
            this.ruleForm.img = "data:image/png;base64," + data.datas.code;
          },
          (data) => {
            console.log(data);
          }
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  beforeRouteLeave(to, from, next) {
    $(window).off("scroll");
    $("html").css({ height: "100%" });
    next();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
@import "../../assets/scss/base.scss";

@function rem($pixels) {
  @return $pixels / $font_size +rem;
}

// div,
// a,
// h4,
// span {
//   -webkit-transition: all 0.4s ease-in-out 0s;
//   -o-transition: all 0.4s ease-in-out 0s;
//   -moz-transition: all 0.4s ease-in-out 0s;
//   transition: all 0.4s ease-in-out 0s;
// }
img {
  -webkit-transition: all 0.8s ease-in-out 0s;
  -o-transition: all 0.8s ease-in-out 0s;
  -moz-transition: all 0.8s ease-in-out 0s;
  transition: all 0.8s ease-in-out 0s;
}

.enlarge1_2x {
  -webkit-transform: scale(1.2);
  -moz-transform: scale(1.2);
  -o-transform: scale(1.2);
  transform: scale(1.2);
}

.enlarge1_5x {
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
  -o-transform: scale(1.5);
  transform: scale(1.5);
}

.header-box {
  position: absolute;
  z-index: 999;
  background: rgba(0, 0, 0, 0);
  top: 0px;
}

.header-box-fix {
  position: fixed;
  z-index: 999;
}

.min-height {
  height: 142px;
}

/*--------------------核心产品-------------------*/
.core-area {
  width: 100%;
  height: 565px;
  background-color: #f4f2f2;
  // transform:translateY(-10px)
}

.core-area-content {
  width: 1200px;
  margin: 0 auto;
}

.core-area-content-con {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.core-area-title {
  width: 1200px;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 30px;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #323232;
  line-height: 0.94;
  text-align: center;

  span {
    display: block;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
    margin-top: 18px;
  }
}

.quzheng {
  color: #fff;

  span {
    background: #fff;
  }
}

.core-lump {
  // float: left;
  // margin-top: 38px;
  padding: 79px 30px 36px 30px;
  // margin-right:16px;
  flex-shrink: 0px;
  box-sizing: border-box;
  width: 288px;
  height: 390px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  transition: box-shadow 0s;
}

.core-lump:hover {
  box-shadow: 0px 0px 6px 0px rgba(163, 147, 116, 0.4);
}

.core-lump:hover img {
  transition: transform 1s;
  transform: rotateY(180deg);
}

.core-lump:hover p {
  color: #000000;
}

.core-lump>img {
  display: block;
  margin: 0 auto;
}

.lump-title {
  text-align: center;
  margin-top: 30px;
}

.lump-title>h3 {
  // letter-spacing: 1.1px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  // cursor: pointer;
}

.core-lump:hover>.lump-title>h3 {
  // cursor: pointer;
  color: $bg !important;
}

.lump-title>p {
  width: 100%;
  margin: auto;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #828282;
  line-height: 22px;
}

.lump-title>span {
  width: 28px;
  height: 2px;
  background: #cdcdcf;
  display: inline-block;
  margin-bottom: 10px;
  margin-top: 18px;
}

::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #999;
  font-size: 12px;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #999;
  font-size: 12px;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #999;
  font-size: 12px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #999;
  font-size: 12px;
}

#index-wrap {
  font-size: 14px;
  color: #7c7b7b;
}

#index-wrap .content {
  position: relative;
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

#index-wrap .content .block-title {
  height: 90px;
  text-align: center;
}

#index-wrap .content .block-title>span {
  font-size: 24px;
  color: #333;
  font-weight: 700;
  padding: 0 48px;
  display: inline-block;
  height: 90px;
  line-height: 90px;
}

#index-wrap .content .block-title>span.block-title-gray {
  background-color: #f6f6f6;
}

#index-wrap .content .abstract {
  width: 871px;
  text-align: center;
  color: #7d7d7d;
  line-height: 20px;
  height: 40px;
  margin: 0 auto;
}

.banner-wrapper {
  position: absolute;
  top: 70px;
  left: 0;
  z-index: 4;
  width: 1200px;
  height: 440px;
  -webkit-transition: all 0.7s ease-in-out 0s;
  -o-transition: all 0.7s ease-in-out 0s;
  -moz-transition: all 0.7s ease-in-out 0s;
  transition: all 0.7s ease-in-out 0s;
}

.banner-wrapper:hover {
  transform: scale(1.1, 1.1);
  -webkit-transform: scale(1.1, 1.1);
  -o-transform: scale(1.1, 1.1);
  -moz-transform: scale(1.1, 1.1);
}

.banner-wrapper .banner-layer {
  position: absolute;
  opacity: 0;
  -webkit-transition: all 1s ease-in-out 0s;
  -o-transition: all 1s ease-in-out 0s;
  -moz-transition: all 1s ease-in-out 0s;
  transition: all 1s ease-in-out 0s;
}

.banner-wrapper .banner-layer.layer1 {
  z-index: 3;
  top: 60px;
}

.banner-wrapper .banner-layer.layer1.move {
  opacity: 1;
  top: 0;
}

.banner-wrapper .banner-layer.layer2 {
  z-index: 2;
  top: 120px;
}

.banner-wrapper .banner-layer.layer2.move {
  opacity: 1;
  top: 0;
}

/*-------------------头部-------------------*/

.focus-box {
  height: 440px;
}

.focus-box .focus-box-swiper {
  height: 100%;
  text-align: center;
}

#index-wrap .header {
  position: relative;
}

#index-wrap .header .content {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
}

.login {
  height: 302px;
  width: 310px;
  padding: 15px 20px 0;
  position: absolute;
  right: 0;
  top: 74px;
  z-index: 998;
  background-color: rgba(255, 255, 255, 1);
}

.login h4 {
  font-size: 16px;
  line-height: 16px;
  height: 20px;
  color: #424446;
  font-weight: normal;
  text-align: center;
}

.login p {
  margin-top: 20px;
  position: relative;
}

.login p img.tipIcon {
  position: absolute;
  z-index: 2;
  left: 11px;
  top: 9px;
}

.login p input {
  height: 36px;
  padding-left: 38px;
  border: 1px solid #dcdcdc;
}

.login p input:focus {
  border-color: $btn;
}

.login p input.long-input {
  width: 270px;
}

.login p input.short-input {
  width: 180px;
  float: left;
}

.login span.total-tips {
  position: absolute;
  width: 270px;
  text-align: center;
  color: $error-text;
}

.login p span.err-tips {
  position: absolute;
  color: $error-text;
  left: 0;
  font-size: 12px;
  top: 37px;
}

.login p img.vcode {
  float: right;
  width: 80px;
  height: 36px;
  cursor: pointer;
}

.login p button {
  width: 270px;
  height: 36px;
  line-height: 36px;
  background-color: $btn;
  color: #fff;
  font-size: 16px;
}

.login p button:hover {
  background-color: $btn-hover;
}

.login div.more-option {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  width: 100%;

  span {
    color: #888888;
    cursor: pointer;
  }

  a {
    cursor: pointer;
    color: $btn;
  }
}

/*-------------------产品优势-------------------*/
.product-core {
  height: 532px;
  background: #ffffff;

  .product-core-title {
    width: 1200px;
    padding-bottom: 30px;
    padding-top: 80px;
    font-size: 30px;
    font-weight: 500;
    color: #000000;
    margin: 0 auto;
  }

  .subitem-box {
    display: flex;
    width: 100%;
    justify-content: space-between;

    .core-desc {
      width: 480px;

      p {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 30px;
      }

      p:nth-child(2) {
        padding-top: 20px;
      }
    }

    .core-list {
      display: flex;
      width: 563px;
      flex-wrap: wrap;
      justify-content: space-between;

      p {
        width: 161px;

        img {
          width: 161px;
          margin-bottom: 6px;
        }

        span {
          font-size: 14px;
          font-weight: 500;
          color: #000000;
        }
      }

      .marginbtm {
        margin-top: 3px;
        margin-bottom: 19px;
      }
    }
  }
}

/*-------------------API开放接口-------------------*/
.forensics-home {
  height: 474px;
  background-color: #fbfbfb;
}

.forensics-home .subitem-box {
  height: 255px;
  width: 100%;
  // margin-top: 60px;
  display: flex;
  justify-content: space-between;
  // overflow: hidden;
}

.forensics-home .subitem-box .subitem {
  box-sizing: border-box;
  padding: 40px 15px;
  color: #fff;
  cursor: context-menu;
  transition: margin-top 0.5s;
  text-align: center;
  width: 240px;
  position: relative;

  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #646464;
    line-height: 28px;
    margin-bottom: 10px;
    margin-top: 14px;
  }

  p {
    font-size: 16px;
    font-weight: 500;
    color: #969696;
    line-height: 24px;
  }
}

.forensics-home .subitem-box .subitem:nth-child(2) {
  margin: 0;
}

.subitem:nth-of-type(2) {
  margin: 0 60px;
}

.forensics-home .subitem-box .subitem img {
  display: block;
  width: 60px;
  height: 60px;
  margin: 0 auto;
}

.forensics-home .subitem-box .subitem .connect {
  width: 91px;
  height: 8px;
  position: absolute;
  top: 161px;
  left: 234px;
}

.forensics-home .subitem-box .subitem-info-icon:hover {
  animation: tada 1.5s ease infinite;
}

@-webkit-keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

/*-------------------技术赋能-------------------*/
.technology {
  width: 100%;
  height: 446px;
  background: #d81212;
  position: relative;

  .technology-line {
    width: 100%;
    height: 2px;
    background: #ffffff;
    opacity: 0.5;
    position: absolute;
    top: 50%;
    left: 0px;
    margin-top: -1px;
  }

  .technology-box {
    width: 100%;

    dl {
      width: 220px;
      float: left;
      text-align: center;
      margin-right: 106px;

      dt {
        width: 72px;
        height: 117px;
        margin: 0 auto;
        margin-bottom: 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      dd {
        color: #ffffff;

        h4 {
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          font-weight: 400;
          line-height: 18px;
        }
      }
    }

    dl:last-child {
      margin-right: 0px;
    }
  }
}

/* ----------------------存证记录--------------------- */
.blockChainItem {
  padding-bottom: 50px;
  background: #f1f0f0;
  padding-top: 58px;

  .blockChainItem_con {
    width: 1200px;
    border: 1px solid #d2d2d2;
    margin: 0 auto;

    .blockChainItem_title {
      padding-top: 18px;

      img {
        width: 320px;
        display: block;
        margin: 0px auto 18px auto;
      }
    }
  }
}

.table {
  width: 1198px;
  text-align: center;
  // border-spacing: 0;
  // border-collapse: collapse;
  /*margin-top: 20px;*/
  position: relative;
  overflow: hidden;
  background: #fff;
}

.table tr td {
  // /*border: solid 1px #f8e38d;*/
  color: #888888;
  font-size: 14px;
  /*line-height: 30px;*/
  padding: 10px;
  line-height: 26px;
  box-sizing: border-box;
}

// .table>tr:nth-child(odd),
// .table thead>tr:nth-child(odd),
// .table tbody>tr:nth-child(odd) {
//   background-color: #e4e4e4;
// }

.table>tr:hover,
.table thead>tr:hover,
.table tbody>tr:hover {
  background-color: #e4e4e4;
}

.table>thead td {
  background-color: #e4e4e4;
}

.table-list {
  position: absolute;
  left: 0;
  top: 42px;
  z-index: 2;
}

.table>.table-list>tr {
  background-color: #e4e4e4;
}

.common-tr {
  background-color: #e4e4e4 !important;
}

.common-td {
  width: 16%;
  color: #606063 !important;
  float: left;
  height: 42px;
}

table * {
  box-sizing: border-box;
}

table.table {
  width: 100%;
  border-collapse: collapse;
  color: #7e7e7e;
  /*overflow: hidden;*/
}

table.table tr td {
  border: 0px;
}

table.table {
  border: 0px;
}

.table>tr:nth-child(1),
.table thead>tr:nth-child(1) {
  background-color: #f2f2f2 !important;
  font-weight: 700;
}

.table>tr,
.table thead>tr,
.table>tbody>tr {
  background-color: #fffcf0;
}

.table>tr>td,
.table thead>tr>td,
.table>tbody>tr>td,
.table>tr>th,
.table thead>tr>th,
.table tbody>tr>th {
  height: 42px;
  text-align: center;
  vertical-align: middle;
  word-break: break-all;
  font-size: 14px;
}

.table>tr:hover,
.table tbody>tr:hover {
  background-color: #fcfcfc;
}

// .table>tr:nth-child(odd),
// .table thead>tr:nth-child(odd),
// .table tbody>tr:nth-child(odd) {
//   background-color: #e4e4e4;
// }

.searchs {
  width: 100%;
  height: auto;
  background-color: #f1f0f0;
  padding-top: 60px;
  padding-bottom: 40px;
  position: relative;

  .search_warrp {
    max-width: 1200px;
    margin: 0 auto;

    .headerCellCustomer {
      background: #e4e4e4;
      font-size: 16px;
      font-weight: 500;
      color: #595959;
      border-right: 1px solid #d2d2d2;
    }

    .cellCustomer {
      height: 40px;
      text-align: center;
      line-height: 40px;
      padding: 0;
      color: #969696;
    }

    .search_type {
      margin: 0 auto;
      width: 440px + 47px;
      padding-bottom: 40px;
      margin-bottom: 20px;

      input::-webkit-input-placeholder {
        color: #c8c8c8;
      }

      input:-moz-placeholder {
        color: #c8c8c8;
      }

      input::-moz-placeholder {
        color: #c8c8c8;
      }

      input:-ms-input-placeholder {
        color: #c8c8c8;
      }

      input {
        width: 430px;
        height: 40px;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 8px 0 0 8px;
        font-size: 16px;
        outline: none;
        padding-left: 10px;
        float: left;
        color: #646464;
      }

      div {
        width: 40px;
        height: 42px;
        background: url("../../assets/images/image/search/search_icon_nor.png") no-repeat;
        background-size: 100% 100%;
        // border: 1px solid #b41c2e;
        border-radius: 0 8px 8px 0;
        padding: 0;
        vertical-align: middle;
        outline: none;
        float: left;
        cursor: pointer;
      }
    }
  }

  .no-data {
    img {
      margin: 0 auto;
      width: 28px;
    }
  }
}

/* ----------------------合作伙伴--------------------- */
.cooperators {
  width: 100%;
  background: #ffffff;
  padding-bottom: 60px;

  .subitem-box {
    width: 100%;
  }

  .cooperators-item {
    width: 200px;
    height: 100px;
    background: #ffffff;
    text-align: center;
    line-height: 100px;
  }

  td {
    border: 1px solid #dcdcdc;
  }

  img {
    width: auto;
    height: auto;
    display: inline-block;
    vertical-align: middle;
  }

  td:hover img {
    transform: scale(1.06);
    transition: transform 0.4s ease-in-out 0s;
  }
}

/**/
.more-fn {
  width: 40px;
  height: 90px;
  position: fixed;
  z-index: 999;
  right: 15px;
  bottom: 20px;
}

.more-fn .single-fn {
  width: 40px;
  height: 40px;
  background: #999494;
  overflow: hidden;
  cursor: pointer;
}

.more-fn .single-fn:hover {
  background: #706969;
}

.more-fn .single-fn img {
  display: block;
  width: 40px;
  height: 40px;
}

.more-fn .backtop {
  margin-top: 10px;
}

/*transition Start*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  /*transition: 1s;*/
  opacity: 0;
}

/*transition End*/

/* banner 动画 */

/*头部banner*/

.blockChain-banner {
  width: 100% !important;
  height: 440px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background: url("../../assets/images/index/banner_3.png");

  .container {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    height: 100%;

    .banner1-img {
      height: 180px;
      position: absolute;
      top: 129px;
      left: 167px;
    }

    .banner2-img {
      height: 180px;
      position: absolute;
      top: 115px;
      left: 0px;
      width: 708px;
      color: #fff;
      text-align: left;

      .banner2-img-title {
        height: 73px;
        font-size: 32px;
        font-weight: 800;
        text-align: left;
      }

      .banner2-img-desc {
        width: 650px;
        text-align: left;
        font-size: 20px;
        color: #fad6d6;
        line-height: 36px;
      }
    }

    .banner3-img {
      height: 180px;
      position: absolute;
      top: 129px;
      left: 0px;
      width: 708px;
      color: #fff;
      text-align: left;

      .banner3-img-title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 73px;
      }

      .banner3-img-desc {
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #f5f5f5;
        margin: 0 auto;
        margin-top: 14px;
        font-size: 22px;
        font-weight: 500;
        line-height: 40px;
      }
    }
  }
}

.banner-content-wrap {
  width: 720px;
  margin: 0 auto;
}

.detail {
  overflow: hidden;
  display: block;
  width: 460px;
  text-align: left;
  margin-top: 30px;
  margin-left: 90px;
  /*margin:30px auto;*/
}

.banner-button-wrap {
  background: $reminder-border;
  border-radius: 20px;
}

.banner-button-wrap:hover {
  background: $reminder-border;
}

.banner-button {
  /*文字*/
  width: 148px;
  height: 40px;
  font-size: 14px;
  line-height: 14px;
  color: #ffffff;
  /*margin-left:130px;*/
}

/*banner动画*/
@keyframes righteaseAnimate {
  0% {
    transform: translateX(2000px);
    opacity: 0;
  }

  100% {
    transform: translateX(0px);
    opacity: 1;
  }

  @-webkit-keyframes righteaseAnimate {
    0% {
      -webkit-transform: translateX(2000px);
      opacity: 0;
    }

    100% {
      -webkit-transform: translateX(0px);
      opacity: 1;
    }
  }

  @-o-keyframes righteaseAnimate {
    0% {
      -o-transform: translateX(2000px);
      opacity: 0;
    }

    100% {
      -o-transform: translateX(0px);
      opacity: 1;
    }
  }

  @-moz-keyframes righteaseAnimate {
    0% {
      -moz-transform: translateX(2000px);
      opacity: 0;
    }

    100% {
      -moz-transform: translateX(0px);
      opacity: 1;
    }
  }

  @-ms-keyframes righteaseAnimate {
    0% {
      -ms-transform: translateX(2000px);
      opacity: 0;
    }

    100% {
      -ms-transform: translateX(0px);
      opacity: 1;
    }
  }
}

.detail {
  opacity: 0;
  animation: righteaseAnimate 0.6s ease 0.6s 1;
  -webkit-animation: righteaseAnimate 0.6s ease 0.6s 1;
  -o-animation: righteaseAnimate 0.6s ease 0.6s 1;
  -moz-animation: righteaseAnimate 0.6s ease 0.6s 1;
  -ms-animation: righteaseAnimate 0.6s ease 0.6s 1;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  -ms-animation-fill-mode: forwards;
}

/* 新增 */
.loginDisabled {
  background-color: #a9aaac !important;
}

/* 区块链 */
.blockChain-content {
  height: 100px;
  /*box-shadow: 0px 10px 5px #000;*/
  box-shadow: 0px 15px 10px -15px #ccc;
}

.blockChain {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  box-shadow: 0px 15px 10px -15px #ccc;
}

.block-height,
.node-number,
.transaction-number {
  width: 370px;
  height: 100px;
  float: left;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
  text-align: center;
  position: relative;
  padding-top: 25px;
  padding-bottom: 25px;
}

.block-height:hover,
.node-number:hover,
.transaction-number:hover {
  background-color: rgba(255, 255, 255, 0.45);
}

.node-number {
  margin-left: 45px;
  margin-right: 45px;
}

.block-height {}

.align {
  width: -moz-fit-content;
  width: -webkit-fit-content;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.align>img {
  margin: 0 auto;
  float: left;
}

.nodata-list {
  width: 200px;
  margin: 0 auto;
  height: 100px;
  margin-top: 25%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 16px;

  img {
    width: 80px;
  }
}

/**电子签约登录 */

.loginBox {
  position: relative;
  max-width: 1200px;
  height: 508px;
  margin: 0 auto;
  z-index: 99;

  .loginRight {
    width: 310px;
    overflow: hidden;
    background-color: #fff;
    box-sizing: border-box;
    margin: 56px 0;
    // border-radius: 4px;
    box-shadow: 0 2px 8px 0;
    padding: 15px 20px 0;

    .errorHint {
      width: 270px;
      height: 28px;
      line-height: 28px;
      background: #fffbf3;
      border: 1px solid #ff8c36;
      font-size: 12px;
      text-indent: 10px;
      color: #646464;

      img {
        vertical-align: middle;
        margin-right: 4px;
      }
    }

    .loginTitle {
      color: #5f5f5f;
      line-height: 16px;
      font-size: 16px;
      font-weight: normal;
      margin-bottom: 27px;
      font-family: "PingFangSC-Regular";
    }

    p {
      margin-bottom: 22px;

      input {
        width: 270px;
        height: 36px;
      }

      .inputText {
        border: 1px solid #d1d1d1;
        text-indent: 10px;
      }

      .loginBtn {
        background: #d81212;
        color: #fff;
        font-family: "PingFangSC-Regular ";
        border: none;
      }

      .loginBtn:hover {
        background: #c41515;
      }
    }

    p:nth-child(2) {
      margin-bottom: 10px;
    }

    .lgTigger {
      color: #5f5f5f;
      height: 32px;
      text-align: center;

      span {
        cursor: pointer;
      }

      span:hover {
        color: #c41515;
      }

      .lines:hover {
        color: #5f5f5f;
      }
    }

    .codeCon {
      input {
        width: 166px;
        height: 36px;
        border: 1px solid #d1d1d1;
        text-indent: 10px;
      }

      .verCode {
        display: inline-block;
        width: 90px;
        height: 36px;
        border: 1px solid #d1d1d1;
        margin-left: 10px;
        vertical-align: middle;
      }
    }

    .el-form-item {
      width: 270px;
      height: 36px;

      .el-form-item__content {
        line-height: 32px;
        margin: 0 !important;

        .el-input {
          height: 34px;
        }

        .el-input__inner {
          height: 100%;
          border-radius: 0;
        }

        .el-button--success {
          height: 36px;
          width: 100%;
          background: #d81212;
          border: none;
        }

        .el-button--success:hover {
          background-color: #c41515;
        }
      }

      .code {
        display: block;
        float: right;
        width: 90px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        border: 1px solid #d1d1d1;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .PhotoCode {
        width: 110px;
      }
    }

    .el-form-item:nth-child(3) {
      .el-input {
        width: 160px;
      }
    }

    .demos-ruleForm {
      .el-form-item:nth-child(1) {
        border: 1px solid #d1d1d1;

        .el-input__inner {
          border: 0;
          border-left: 1px solid #d1d1d1;
        }

        .el-input {
          width: 80%;
        }
      }

      .el-form-item:nth-child(2) {
        .el-input {
          width: 140px;
        }
      }
    }
  }

  .loginCode {
    display: none;
    overflow: hidden;
    padding-bottom: 0;
    margin: 102px 0;

    .codePhone {
      border: 1px solid #d1d1d1;

      span {
        display: inline-block;
        width: 50px;
        text-align: center;
        border-right: 1px solid #dcdcdc;
        vertical-align: middle;
      }

      input {
        width: 217px;
        text-indent: 10px;
      }
    }

    .codeVerify {
      border: 1px solid #d1d1d1;

      span {
        display: inline-block;
        width: 100px;
        text-align: center;
        border-left: 1px solid #dcdcdc;
        vertical-align: middle;
        font-size: 14px;
      }

      span:hover {
        color: #c41515;
      }

      input {
        width: 167px;
        text-indent: 10px;
      }
    }

    .switchUser {
      font-family: "PingFangSC-Regular";
      color: #5f5f5f;
      line-height: 12px;
      cursor: pointer;
    }

    .switchUser:hover {
      color: #c41515;
    }
  }
}</style>
